module.exports = __webpack_public_path__ + "imgesssyaa/svg/Code.66cddc36.svg";